module.exports = __webpack_public_path__ + "img/formu-simple.3e4cb4c1.png";